const AppConstants = Object.freeze({
	APP_NAME: "@@APP_NAME@@",
	APP_CODE: "@@APP_CODE@@",

	BANK_NAME: "EXAMPLE BANK",
	I18N_CODES: ['BAD', 'ARM_CORE_PRINT'],
	VERSIONE: '0.0.13-SNAPSHOT',
	REST_SERVER: "localhost",
	REST_BASE_URL: '@@REST_BASE_URL@@',
	// APP_LANG: ['IT', 'EN', 'AL', 'FR'],
	APP_LANG: [
		{ label: 'Italiano', value: 'IT' },
		{ label: 'Inglese', value: 'EN' },
		{ label: 'Albanese', value: 'AL' },
		{ label: 'Francese', value: 'FR' }
	],

	DEFAULT_LANG: 'IT',  //lingua di avvio dell'applicazione
	SHOW_STORE_INFO: '@@SHOW_STORE_INFO@@',
	MODE_STUB: 'false',
	SKIP_LOGIN: false,
	AUTHENTICATION_METHOD: '@@AUTHENTICATION_METHOD@@',

	DEBUG_VIEW: '@@DEBUG_VIEW@@',
	LOGIN_FORM: '@@LOGIN_FORM@@',

	CLASS_BOOSTRAP_TABLE: "table table-striped table-hover",
	CLASS_TABLE: "table table-striped table-hover"

});

/*
@@DEBUG_VIEW@@',
// REST_BASE_URL: 'http://localhost:8080/arm_am/seam/resource/rest/',
// REST_BASE_URL: 'http://citi.armundia.com/wpbz/seam/resource/rest/', // DEFAULT
REST_BASE_URL: 'http://192.168.121.202:8180/arm_am/seam/resource/rest/', // mirko interna
//REST_BASE_URL: "http://37.182.206.177:8180/arm_am/seam/resource/rest/", // mirko dall'esterno
*/

exports.AppConstants = AppConstants;